import PropTypes from "prop-types";
import React from "react";

export default function Footer({ email, scholar, faculty }) {
  return (
    <footer id="contact" className="site-footer content-width">
      <div className="footer-intro">
        <p>让想法，生长为新的可能。</p>
        <a href={`mailto:${email}`}>
          欢迎交流研究与合作 <span aria-hidden="true">↗</span>
        </a>
      </div>
      <div className="footer-bottom">
        <div>
          <a className="footer-name" href="#home">
            郭泽华 <span lang="en">Zehua Guo</span>
          </a>
          <p>上海交通大学 · 农业与生物学院</p>
        </div>
        <nav aria-label="联系方式">
          <a href={faculty} target="_blank" rel="noreferrer">
            学校主页 <span aria-hidden="true">↗</span>
          </a>
          <a href={`mailto:${email}`}>
            邮件联系 <span aria-hidden="true">↗</span>
          </a>
          <a href={scholar} target="_blank" rel="noreferrer" lang="en">
            Google Scholar ↗
          </a>
          <a href="https://github.com/alex90thu" target="_blank" rel="noreferrer" lang="en">
            GitHub ↗
          </a>
        </nav>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  email: PropTypes.string.isRequired,
  scholar: PropTypes.string.isRequired,
  faculty: PropTypes.string.isRequired,
};
